// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page___1q-7c"};